var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Front"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 0C22.6569 0 24 1.34315 24 3V13.5C24 15.1569 22.6569 16.5 21 16.5H3C1.34315 16.5 0 15.1569 0 13.5V3C0 1.34315 1.34315 0 3 0H21ZM21 1.5H3C2.23075 1.5 1.59674 2.07906 1.51009 2.82507L1.5 3V13.5C1.5 14.2693 2.07906 14.9033 2.82507 14.9899L3 15H21C21.7693 15 22.4033 14.4209 22.4899 13.6749L22.5 13.5V3C22.5 2.23075 21.9209 1.59674 21.1749 1.51009L21 1.5ZM15.75 9C16.1642 9 16.5 9.33579 16.5 9.75C16.5 10.1642 16.1642 10.5 15.75 10.5H12.75C12.3358 10.5 12 10.1642 12 9.75C12 9.33579 12.3358 9 12.75 9H15.75ZM20.25 6C20.6642 6 21 6.33579 21 6.75C21 7.16421 20.6642 7.5 20.25 7.5H12.75C12.3358 7.5 12 7.16421 12 6.75C12 6.33579 12.3358 6 12.75 6H20.25Z",
    fill: "#0B3A5F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99977 9.25C5.67891 9.25 4.50427 9.88776 3.75644 10.8775C3.59549 11.0905 3.51501 11.197 3.51764 11.341C3.51967 11.4522 3.58951 11.5925 3.67701 11.6611C3.79027 11.75 3.94722 11.75 4.26112 11.75H9.73843C10.0523 11.75 10.2093 11.75 10.3225 11.6611C10.41 11.5925 10.4799 11.4522 10.4819 11.341C10.4845 11.197 10.4041 11.0905 10.2431 10.8775C9.49528 9.88776 8.32064 9.25 6.99977 9.25Z",
    stroke: "#0B3A5F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99978 8C8.03531 8 8.87478 7.16053 8.87478 6.125C8.87478 5.08947 8.03531 4.25 6.99978 4.25C5.96424 4.25 5.12478 5.08947 5.12478 6.125C5.12478 7.16053 5.96424 8 6.99978 8Z",
    stroke: "#0B3A5F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdFront);
export default __webpack_public_path__ + "static/media/id-front.95360a1b618e855f49f7d04fe8af5127.svg";
export { ForwardRef as ReactComponent };